import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LoginApiServiceService {
  isLogin:string = '';

  constructor(private http: HttpClient) { }

  api: string = environment.baseUrl;

  //login api
  getLoginData(email: string, password: string) {
    var body = {
      userName: email,
      password: password
    }
    return this.http.post(this.api + 'login', body)
  }

  //refresh api
  getRefreshToken(RefreshToken: any) {
    return this.http.get(this.api + 'RefreshToken/' + RefreshToken)
  }


}
